// print title text for FullArticleView
const TitleText = ({ text }) => {
  return <h4>{text}</h4>;
};

export default TitleText;
